<template>
  <div class="container orderconfirm">
    <div class="container-car">
      <header class="carBanner">
        <div class="car-header"></div>
      </header>
      <div class="order-container">
        <div class="orderCar title_order" @click.stop="repalceAddr()">
          <div class="title_info">
            <i class="iconfont iconadress"></i>
          </div>
          <div class="title_con" v-if="addressList.length > 0">
            <div class="person font-12">
              <p class="name">{{ addressObj.receiver }}</p>
              <p class="phone">{{ addressObj.receiver_mobile }}</p>
            </div>
            <div class="person font-12">
              <p class="txt_two">{{ addressObj.receive_addr }}</p>
            </div>
          </div>
          <div class="title_no font-12" v-else>
            {{ $t('orderConfirm.Addshippingaddress') }}
          </div>
          <div class="title_info">
            <img
              class="edit"
              src="../../assets/assemble/img/go_arrow.png"
              alt=""
            />
          </div>
        </div>
        <div class="orderCar con_order">
          <div class="carName" v-if="freightFlag">
            <img
              class="title_img"
              src="../../assets/assemble/img/shop-icon.png"
              alt=""
            />
            <!-- <div class="shop_title">{{orderObj.productSuppliersName}}</div> -->
            <p>{{ $t('orderConfirm.cannotbedelivered') }}</p>
          </div>
          <div class="good_con">
            <div class="goodImg">
              <img :src="orderObj.txtDetailImg" alt="" />
            </div>
            <div class="good_detail">
              <h6 class="txt-two-line">{{ orderObj.productName }}</h6>
              <p class="good_norm">
                {{ $t('orderConfirm.Specifications') }}：{{ orderObj.level }}
              </p>
            </div>
            <div class="good_price">
              <div class="money font-12">
                ￥<span class="font-14 font_num">{{
                  orderObj.spellGroupPrice | numFilter
                }}</span>
              </div>
              <div>x{{ orderObj.quantity }}</div>
            </div>
          </div>
          <div class="good_foot">
            <div class="remark">
              <p style="text-align: left;">{{ $t('orderConfirm.Ordernotes') }}：</p>
              <p class="remark_bz" style="color: #999;"  @click="isRemarkShow(true)" v-if="remark === ''">{{ $t('orderConfirm.Optional') }}</p>
              <p class="remark_bz" @click="isRemarkShow(true)" v-else> {{ remark }}</p>
              <!-- <input style="font-size: 13px;" class="remark_bz" type="text" v-model="remarks.txt_product_suppliers_name" placeholder="选填" maxlength="200"> -->
            </div>
            <div class="total_price">
              {{ $t('orderConfirm.Subtotal') }}：
              <div class="money font-bold">
                ￥
                <span class="exp font-14 font_num_bold">
                  {{
                    (orderObj.spellGroupPrice * orderObj.quantity) | numFilter
                  }}
                </span>
              </div>
            </div>
            <div class="fare">
              ( {{ $t('orderConfirm.Including') }}：
              <div class="money">
                ￥<span class="font-12 font_num"
                  >{{ freight | numFilter }})</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shopFooter font-12">
        <div class="sum">{{ $t('orderConfirm.Total') }}：</div>
        <div class="money foot_total">
          <span class="RMB">￥</span
          ><span class="font-16 font_num_bold">{{
            (orderObj.spellGroupPrice * orderObj.quantity + freight) | numFilter
          }}</span>
        </div>
        <div
          class="sub_btn font-14"
          :class="{ active: !isDisable || freightFlag }"
          @click="isDisable && !freightFlag && submit()"
        >
          {{ $t('orderConfirm.Submit') }}
        </div>
      </div>
    </div>
    <van-popup v-model="remarkShow" round position="bottom" :style="{ height: '30%' }">
      <div class="popup">
        <div style="display: flex;padding: 12px 5% 0;justify-content: space-between;">
            <p style="font-size: 14px;" @click="isRemarkShow(false)">{{ $t('productDetail.Cancel') }}</p>
            <p style="font-size: 16px;font-weight: 500;">{{ $t('orderConfirm.Ordernotes') }}</p>
            <p style="font-size: 14px;" @click="isRemarkShow(false)">{{ $t('productDetail.Confirm') }}</p>
        </div>
        <van-field
          v-model="remark"
          rows="4"
          autosize
          type="textarea"
          maxlength="200"
          show-word-limit
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import '../../assets/assemble/font-icon/iconfont.css'

export default {
  data () {
    return {
      addressObj: {},
      re_addr: '',
      freight: 0,
      addressList: [],
      shopList: [],
      assProduct: {},
      orderScene: '',
      remark: '',
      remarkShow: false,
      isDisable: true,
      freightFlag: false,
      ssoToken: this.$localStorageUtil.getCurrentUserToken()
    }
  },
  created () {
    // 页面刷新
    this.$common.reloadPage()
    // 获取订单信息
    this.getList()
    this.getAddressList()
  },
  methods: {
    // 获取商品信息
    getList () {
      this.orderObj = this.$localStorageUtil.getOrderConfirmInfo()
    },
    // 获取地址
    getAddressList () {
      let param = {
        params: {
          ssoToken: this.ssoToken
        }
      }
      this.axios.get(this.$urlConfig.fafuliMallAdminUrl() + 'receive/addressList', param).then(res => {
        if (res.data && res.data !== 'error') {
          this.addressList = res.data
          if (this.addressList.length === 0) {
            this.$toast(this.$t('orderConfirm.currently'))
          } else {
            this.addressList.forEach(item => {
              // 取默认地址， 如果没有默认地址 取第一个地址
              if (item.isdefault === '1') {
                this.addressObj = item
              } else {
                this.addressObj = this.addressList[0]
              }
            })
          }
        }
      }).then(() => {
        this.getExpress()
      })
    },
    // 运费
    getExpress () {
      let param = {
        c2: this.addressObj.txt_city_code,
        codes: this.orderObj.productCode,
        detailCodes: this.orderObj.productDetailCode,
        price: this.orderObj.spellGroupPrice
      }
      this.axios.post(this.$urlConfig.fafuliMallAdminUrl() + 'product/getExpress', param).then(res => {
        if (res.data.freight || res.data.freight === 0) {
          this.freight = Number(res.data.freight)
          this.freightFlag = false
        } else {
          this.freightFlag = true
        }
      })
    },
    // 替换地址
    repalceAddr () {
      if (this.addressList.length > 0) {
        // 地址列表页
        window.location.href = this.$urlConfig.ssoUiUrl() + 'mall/addressList?pageType=' + 'order'
      } else {
        // 地址编辑页
        window.location.href = this.$urlConfig.ssoUiUrl() + 'mall/addressAdd?pageType=' + 'order'
      }
    },
    isRemarkShow (is) {
      this.remarkShow = is
    },
    submit () {
      if (!this.addressObj.receiver_mobile || !this.addressObj.receiver) {
        this.$toast('收货地址的手机号和姓名不能为空')
        return
      }
      let type = navigator.userAgent.toLowerCase()
      if (type.indexOf('micromessenger') > -1 && (type.indexOf('wxwork') > -1)) {
        // 企业微信
        this.orderScene = '50'
      } else if (type.indexOf('micromessenger') > -1) {
        // 微信端
        this.orderScene = '10'
      } else if (type.indexOf('alipayclient') > -1 || type.indexOf('dingtalk') > -1) {
        // 支付宝 || 钉钉
        this.orderScene = '40'
      } else {
        // 其他（pc）
        this.orderScene = '50'
      }
      // 按钮控制重复提交
      this.isDisable = false
      if (this.orderObj.groupNo) {
        // 参团下单
        let param = {
          orderScene: this.orderScene,
          ssoToken: this.ssoToken,
          companyId: this.$localStorageUtil.getCurrentUserCompanyId(),
          groupNo: this.orderObj.groupNo,
          activityNo: this.orderObj.activityNo,
          productCode: this.orderObj.productCode,
          productDetailCode: this.orderObj.productDetailCode,
          quantity: this.orderObj.quantity,
          orderFreight: this.freight,
          receiverId: this.addressObj.id,
          receiverAddress: this.addressObj.receive_addr,
          receiverMobile: this.addressObj.receiver_mobile,
          receiverName: this.addressObj.receiver,
          remark: this.remark
        }
        this.axios.post(this.$urlConfig.fafuliAssembleApiUrl() + 'assemble_web/join', param).then(res => {
          if (res.data.return_code === '00') {
            window.location.replace(res.data.data.entity.payUrl)
            // 提交后删除订单信息
            this.$localStorageUtil.removeOrderConfirmInfo()
          } else {
            this.$toast(res.data.return_msg)
          }
          setTimeout(() => {
            this.isDisable = true
          }, 2000)
        })
      } else {
        // 开团下单
        let param = {
          orderScene: this.orderScene,
          ssoToken: this.ssoToken,
          companyId: this.$localStorageUtil.getCurrentUserCompanyId(),
          activityNo: this.orderObj.activityNo,
          productCode: this.orderObj.productCode,
          productDetailCode: this.orderObj.productDetailCode,
          quantity: this.orderObj.quantity,
          orderFreight: this.freight,
          receiverId: this.addressObj.id,
          receiverAddress: this.addressObj.receive_addr,
          receiverMobile: this.addressObj.receiver_mobile,
          receiverName: this.addressObj.receiver,
          remark: this.remark
        }
        this.axios.post(this.$urlConfig.fafuliAssembleApiUrl() + 'assemble_web/create', param).then(res => {
          if (res.data.return_code === '00') {
            window.location.replace(res.data.data.entity.payUrl)
            // 提交后删除订单信息
            this.$localStorageUtil.removeOrderConfirmInfo()
          } else {
            this.$toast(res.data.return_msg)
          }
          setTimeout(() => {
            this.isDisable = true
          }, 2000)
        })
      }
    }
  },
  // 局部过滤器
  filters: {
    numFilter (value) {
      if (value) {
        // 截取当前数据到小数点后两位
        let realVal = parseFloat(value).toFixed(2)
        return realVal
      } else {
        return '0.00'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$fontText: 'PingFangSC-Regular';
$fontNum: 'pingfang-medium-num';
$fontNumBold: 'pingfang-sc-bold';

.font_num {
  font-family: $fontNum;
}
.font_num_bold {
  font-family: $fontNumBold;
}
.font-12 {
  font-size: vw(12);
}
.font-14 {
  font-size: vw(14);
}
.font-16 {
  font-size: vw(16);
}
.font-bold {
  font-size: 700;
}
.ff-SC {
  font-family: 'PingFang-SC';
}
.txt-two-line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  word-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}
.orderconfirm {
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  left: 0;
  top: 0;
}
.container-car {
  width: 100%;
  height: 100%;
  padding: 0 0 20vw;
  box-sizing: border-box;
  position: absolute;
  background-color: #f6f6f6;
  -webkit-overflow-scrolling: touch;
}

.order-container {
  padding-bottom: 20vw;
  box-sizing: border-box;
  position: relative;
  -webkit-overflow-scrolling: touch;
}
.carBanner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 48vw;
  background-image: url('../../assets/assemble/img/hall-banner.png');
  -webkit-background-size: cover;
  background-size: cover;
}
.car-header {
  height: 13.33vw;
  width: 100%;
  line-height: 13.33vw;
  color: #fff;
  padding: 0 5.06vw;
  background: transparent;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}

/* 订单内容 */
.orderCar {
  position: relative;
  z-index: 1;
  margin: 2.66vw 3.46vw 0;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0.53vw 0.53vw 2.66vw 0 rgba(125, 81, 39, 0.1);
  border-radius: 2.13vw;
}
.title_order {
  display: flex;
  padding: 5.33vw;
  justify-content: space-between;
}

.title_order .title_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
i.iconfont {
  color: #ff8400;
  font-size: 8vw;
}
.title_order .title_info .adress {
  width: 8vw;
  height: 8vw;
}
.title_order .title_info .edit {
  width: 1.6vw;
  height: 3.26vw;
}
.title_order .title_con {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 4.8vw;
  margin-right: 4vw;
  flex: 1;
}
.title_no {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
  color: #323232;
  margin-left: 4.8vw;
  margin-right: 4vw;
  flex: 1;
}
.title_order .title_con .person {
  display: flex;
  color: #323232;
  padding-bottom: 1.86vw;
}
.title_order .title_con .person .name {
  font-weight: 700;
  margin-right: 5.33vw;
}

/* 订单商品 */
.font-bold {
  /*vertical-align:bottom;*/
  font-weight: 700;
}
.con_order {
  padding: 2.66vw 6.4vw 3.46vw 4.8vw;
}
.carName {
  width: 100%;
  display: flex;
  .shop_title {
    font-size: 3.2vw;
    font-weight: bold;
    color: #323232;
    line-height: 3.72vw;
    font-family: PingFangSC;
  }
  .title_img {
    width: 3.73vw;
    height: 3.73vw;
    margin-right: 2.13vw;
  }
  p {
    color: red;
    font-size: vw(12);
    margin-left: vw(15);
    font-weight: bold;
    line-height: 3.72vw;
  }
}
.good_con {
  position: relative;
  color: #323232;
  overflow: hidden;
  padding: 5.33vw 0 4.53vw;
  display: flex;
  border-bottom: 0.26vw solid #efefef;
}
.good_con .goodImg {
  width: 18.66vw;
  height: 18.66vw;
}
.good_con .goodImg img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 1.33vw;
  border: 0.26vw solid #efefef;
}
.good_detail {
  flex: 1;
  margin-left: 3.46vw;
}
.good_detail h6 {
  font-weight: 400;
  font-size: 3.2vw;
  color: #323232;
  line-height: 4.53vw;
}

.good_detail .good_norm {
  padding-top: 0.53vw;
  color: #a4aab3;
  font-size: 3.2vw;
}
.good_detail .special {
  border: 1px solid #f96750;
  border-radius: 0.8vw;
  color: rgb(199, 83, 0);
}
.good_detail .detail_info {
  display: flex;
  justify-content: space-between;
}
.good_price {
  text-align: right;
  font-size: 3.73vw;
  margin-left: 7vw;
}
.popup {
  position: relative;
  ::v-deep .van-field__label {
    display: none;
  }
  ::v-deep .van-cell__value {
    height: 140px;
    width: 100%;
    overflow-y: auto;
  }
}
.good_foot {
  .remark {
    display: flex;
    justify-content: space-between;
    margin-top: 2vw;
  }
  .remark p {
    display: inline-block;
    width: 50%;
    font-size: 13px;
    height: 20px;
  }
  .remark .remark_bz {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: end;
  }
  text-align: right;
  .van-cell {
    padding: 10px 0px;
  }
  .van-cell::after {
    border-bottom: none;
  }
  ::v-deep .van-cell__title {
    text-align: left;
    width: 80px;
  }
}
.total_price {
  display: flex;
  justify-content: flex-end;
  line-height: 4.53vw;
  padding-top: 2.66vw;
  padding-bottom: 0.8vw;
  font-size: vw(12);
  .exp {
    font-size: vw(14);
  }
}
.fare {
  display: flex;
  font-size: vw(12);
  justify-content: flex-end;
  line-height: 4.53vw;
}
/* 底部 */
.shopFooter {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 1000;
  width: 100%;
  height: 14.93vw;
  line-height: 14.93vw;
  color: #323232;
  padding: 0 3.2vw 0 7.73vw;
  background-color: #fff;
  box-shadow: 0 -0.26vw 1.06vw 0 #cfcfcf;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
}
.shopFooter .sub_btn {
  width: 28vw;
  height: 10.66vw;
  border-radius: 5.33vw;
  background: #ff8400;
  margin-top: 2.13vw;
  text-align: center;
  line-height: 10.66vw;
  color: #fff;
  font-size: 3.73vw;
  font-weight: 700;
  font-family: PingFangSC;
  &.active {
    background: #cfcfcf;
  }
}
.shopFooter .foot_total {
  margin-right: 2.66vw;
  font-weight: 700;
}

.shopFooter .sum {
  display: flex;
  align-items: center;
  color: #131313;
}

.RMB {
  position: relative;
  top: -0.16vw;
}
</style>
